import { render, staticRenderFns } from "./set-player-card.vue?vue&type=template&id=2c0fe0e2&scoped=true&"
import script from "./set-player-card.vue?vue&type=script&lang=js&"
export * from "./set-player-card.vue?vue&type=script&lang=js&"
import style0 from "./set-player-card.vue?vue&type=style&index=0&id=2c0fe0e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0fe0e2",
  null
  
)

export default component.exports